import React, { useState, useEffect, useCallback } from "react";
import axios from '../../api/apiClient';

import {
  CreateTable,
  SearchBar
} from '../../common/APICommon';
import { token, domain } from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

function NightDifferential({ user, isHideSideMenu }) {

  var headers = [
    "ID",
    "Description",
    "Percentage",
    "Is Active",
    "Actions"
  ]
  var accessors = [
    "id",
    "description",
    "percentage",
    "isActive",
    "actions"
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [filterData, setFilterData] = useState([]);
  
  // Form states
  const [description, setDescription] = useState("");
  const [percentage, setPercentage] = useState("");
  const [isActive, setIsActive] = useState(true);
  
  // Modal states
  const [showAddEditForm, setShowAddEditForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");

  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);

  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const apiUrl = domain + "/api/NightDifferential";

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      setData(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = filterData.filter((f) =>
      f?.description.toLowerCase().includes(lowercaseValue)
    );
    setData(res);
  };

  const resetLocalVariables = () => {
    setDescription("");
    setPercentage("");
    setIsActive(true);
    setSelectedData(null);
    setIsEditMode(false);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      description: description,
      percentage: parseFloat(percentage),
      isActive: isActive
    };

    try {
      setLoadingRequest(true);
      
      if (isEditMode && selectedData) {
        // Update
        await axios.put(apiUrl + `/${selectedData.id}`, data, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        setRequestMessage("Night differential updated successfully!");
      } else {
        // Create
        await axios.post(apiUrl, data, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        setRequestMessage("Night differential created successfully!");
      }

      setShowAddEditForm(false);
      await fetchData();
      setIsSuccess(true);
      setShowRequestMessage(true);
    } catch (error) {
      console.error('There was a problem saving data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = error.response?.data?.message || 
        (isEditMode ? "Failed to update night differential" : "Failed to create night differential");
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    resetLocalVariables();
  };

  const editHandleClick = (data) => {
    setSelectedData(data);
    setDescription(data.description);
    setPercentage(data.percentage.toString());
    setIsActive(data.isActive);
    setIsEditMode(true);
    openAddEditHandleClick();
  };

  const openAddHandleClick = () => {
    resetLocalVariables();
    setIsEditMode(false);
    openAddEditHandleClick();
  };

  const openAddEditHandleClick = () => {
    setShowAddEditForm(true);
  };

  const closeAddEditHandleClick = () => {
    setShowAddEditForm(false);
    resetLocalVariables();
  };

  const formatBooleanValue = (value) => {
    return value ? "Yes" : "No";
  };

  const formatPercentage = (value) => {
    return `${value}%`;
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: editHandleClick,
      visible: true,
    },
  ];

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Dev Mode >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Night Differentials"}</span>
              </div>
              <div className="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
                <h3>Night Differentials</h3>
                <button 
                  onClick={openAddHandleClick}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded flex items-center gap-2"
                >
                  <AddIcon fontSize="small" />
                  Add Night Differential
                </button>
              </div>
            </div>
            <div className='p-4 space-y-4'>
              <SearchBar handleFilter={handleFilter} />

              <CreateTable
                tableName={"NightDifferential"}
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={data?.length}
                customRenderers={{
                  percentage: (value) => formatPercentage(value),
                  isActive: (value) => formatBooleanValue(value)
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <AddEditForm
        isOpen={showAddEditForm}
        onClose={closeAddEditHandleClick}
        isEditMode={isEditMode}
        description={description}
        setDescription={setDescription}
        percentage={percentage}
        setPercentage={setPercentage}
        isActive={isActive}
        setIsActive={setIsActive}
        handleSubmit={handleSubmit}
        modalName={isEditMode ? "Edit Night Differential" : "Add Night Differential"}
      />
      <GenerateMessage
        form={showRequestMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      />
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

function AddEditForm({
  isOpen,
  modalName,
  onClose,
  isEditMode,
  description,
  setDescription,
  percentage,
  setPercentage,
  isActive,
  setIsActive,
  handleSubmit
}) {

  const submit = (e) => {
    e.preventDefault();
    handleSubmit(e);
  };

  const handleClose = () => {
    onClose();
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handlePercentageChange = (event) => {
    const value = event.target.value;
    // Allow only numbers and decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setPercentage(value);
    }
  };

  const handleIsActiveChange = (event) => {
    setIsActive(event.target.checked);
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        role="dialog"
        aria-modal="true"
        className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto"
      >
        <div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] rounded-lg shadow-xl h-auto flex flex-col relative">

          {/* Header */}
          <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2">
              <span className="text-xl text-gray-600">{modalName}</span>
            </h2>

            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-700 transition-colors p-1 bg-transparent border-none"
              aria-label="Close modal"
            >
              <CloseIcon fontSize="medium" />
            </button>
          </div>

          {/* Body */}
          <div className="p-6 overflow-y-auto flex-grow">
            <form onSubmit={submit}>
              {/* Night Differential Information */}
              <div className="mb-6 border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
                <div className="py-1 border-b border-gray-300">
                  <h3 className="font-medium text-gray-700">Night Differential Information</h3>
                </div>
                <div className="pb-3">
                  <div className="grid grid-cols-1 gap-4 pt-3">
                    {/* Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Description *
                      </label>
                      <input
                        type="text"
                        value={description}
                        onChange={handleDescriptionChange}
                        className="w-full p-2 border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500 box-border"
                        placeholder="Enter description"
                        required
                      />
                    </div>

                    {/* Percentage */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Percentage *
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          value={percentage}
                          onChange={handlePercentageChange}
                          className="w-full p-2 border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500 box-border pr-10"
                          placeholder="Enter percentage (e.g., 10, 15.5)"
                          required
                        />
                        <span className="absolute right-3 top-2 text-gray-500">%</span>
                      </div>
                      <span className="text-xs text-gray-500 italic">
                        Enter numeric value only (e.g., 10 for 10%)
                      </span>
                    </div>

                    {/* Is Active Checkbox */}
                    <div className="flex items-center space-x-3 pt-2">
                      <input
                        type="checkbox"
                        id="isActive"
                        checked={isActive}
                        onChange={handleIsActiveChange}
                        className="h-4 w-4 text-blue-600"
                      />
                      <label htmlFor="isActive" className="text-gray-800 font-medium">
                        Is Active
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="flex justify-end space-x-2 pt-4">
                <button
                  type="button"
                  onClick={handleClose}
                  className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
                >
                  {isEditMode ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </>
  );
}

export default NightDifferential